/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, inject } from '@angular/core';
import { AbstractResourceService, JsonApiListResourceMetadataBase } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable({
  providedIn: 'root',
})
export class TaskCheckpointResourceService extends AbstractResourceService<
  undefined,
  undefined,
  JsonApiListResourceMetadataBase,
  undefined
> {
  constructor() {
    const httpClient = inject(HttpClient);
    const environmentService = inject(EnvironmentService);

    super(
      httpClient,
      environmentService.getEnvironmentProperty('taskCheckpointUrl'),
      undefined,
      undefined,
      JsonApiListResourceMetadataBase,
      undefined
    );
  }

  unavailable(uuid: string) {
    return this.httpClient?.post(`${this.url}/unavailable/${uuid}`, null, { headers: this.headers }).pipe(this.getDtoMapper());
  }

  handoverFull(taskUuid: string) {
    return this.httpClient?.post(`${this.url}/handover-full/${taskUuid}`, null, { headers: this.headers });
  }
}
